import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import routers from './routers';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

import MaterialKit from "./plugins/material-kit";

// fontawesome icons
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';

Vue.component('fa-icon', FontAwesomeIcon);

// register fontawesome icons and FontAwesomeIcon component;
library.add(fas);
library.add(fab);

Vue.use(VueRouter)
Vue.use(Vuetify)

Vue.config.productionTip = false

Vue.use(MaterialKit);

const NavbarStore = {
  showNavbar: false
};

Vue.mixin({
  data() {
    return {
      NavbarStore
    };
  }
});

new Vue({
  router: routers,
  render: h => h(App),
}).$mount('#app')
